import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircle2, Loader2, ArrowRight, Mail, Phone } from 'lucide-react';
import { contactInfo } from '../mock';
import './PaymentResult.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const POLL_INTERVAL = 2000;
const MAX_POLLS = 15;

const PaymentSuccess = () => {
  const [params] = useSearchParams();
  const sessionId = params.get('session_id');
  const [status, setStatus] = useState(null);
  const [tx, setTx] = useState(null);
  const [pollCount, setPollCount] = useState(0);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!sessionId) {
      setError('Session de paiement introuvable.');
      return;
    }
    let cancelled = false;
    let attempts = 0;

    const poll = async () => {
      attempts += 1;
      setPollCount(attempts);
      try {
        const res = await fetch(`${BACKEND_URL}/api/payments/status/${sessionId}`);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        if (cancelled) return;
        setTx(data);
        setStatus(data.payment_status);
        if (data.payment_status === 'paid') return;
        if (attempts >= MAX_POLLS) {
          setError("Le paiement n'est pas encore confirmé. Vous recevrez un email de Stripe lorsque ce sera confirmé.");
          return;
        }
        setTimeout(poll, POLL_INTERVAL);
      } catch (err) {
        if (cancelled) return;
        console.warn('PaymentSuccess: status poll failed', err);
        setError("Impossible de vérifier le statut du paiement. Contactez Nolan au 06 69 47 75 36.");
      }
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId]);

  const isPaid = status === 'paid';
  const isPolling = !isPaid && !error;

  return (
    <div className="payment-result-page">
      <div className="payment-result-card">
        {isPolling && (
          <>
            <div className="payment-result-icon loading">
              <Loader2 size={48} className="spin" />
            </div>
            <h1>Confirmation du paiement...</h1>
            <p>Nous attendons la confirmation de Stripe. Merci de ne pas fermer cette page.</p>
            <div className="payment-result-poll">Tentative {pollCount}/{MAX_POLLS}</div>
          </>
        )}

        {isPaid && (
          <>
            <div className="payment-result-icon success">
              <CheckCircle2 size={56} strokeWidth={1.6} />
            </div>
            <h1>Paiement reçu ! Merci {tx?.customer_name?.split(' ')[0] || ''}</h1>
            <p>Votre acompte a bien été versé. Nolan vous contacte sous 24h pour démarrer votre projet.</p>

            {tx && (
              <div className="payment-result-summary">
                <div className="prs-row">
                  <span>Offre</span>
                  <span>{tx.offer_label}</span>
                </div>
                <div className="prs-row highlight">
                  <span>Montant versé</span>
                  <span>{(tx.amount / 100).toFixed(2)} {tx.currency?.toUpperCase()}</span>
                </div>
                <div className="prs-row muted">
                  <span>Référence</span>
                  <span className="mono">{sessionId.slice(-16)}</span>
                </div>
              </div>
            )}

            <div className="payment-result-contact">
              <div className="prc-title">Votre contact</div>
              <a href={`mailto:${contactInfo.email}`} className="prc-item"><Mail size={18} /> {contactInfo.email}</a>
              <a href="tel:+33669477536" className="prc-item"><Phone size={18} /> {contactInfo.phone}</a>
            </div>
          </>
        )}

        {error && (
          <>
            <div className="payment-result-icon error">!</div>
            <h1>Un instant...</h1>
            <p>{error}</p>
          </>
        )}

        <Link to="/" className="payment-result-back">
          Retour à l'accueil <ArrowRight size={16} />
        </Link>
      </div>
    </div>
  );
};

export default PaymentSuccess;
